import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo:'login', pathMatch: 'full' },
  { path: 'login', loadChildren: './components/login/login.module#LoginComponentModule' },
  { path: 'insert-user', loadChildren: './components/insert-user/insert-user.module#InsertUserComponentModule' },
  { path: 'home', loadChildren: './components/home/home.module#HomeComponentModule' },
  { path: 'customers', loadChildren: './components/customers/customers.module#CustomersComponentModule' },
  { path: 'products', loadChildren: './components/products/products.module#ProductsComponentModule' },
  { path: 'client-detail', loadChildren: './components/client-detail/client-detail.module#ClientDetailComponentModule'},
  { path: 'equipments', loadChildren: './components/equipments/equipments.module#EquipmentsComponentModule'},
  { path: 'equipment-details', loadChildren: './components/equipment-details/equipment-details.module#EquipmentDetailsComponentModule'},
  { path: 'users', loadChildren: './components/users/users.module#UsersComponentModule'},
  { path: 'user-detail', loadChildren: './components/user-detail/user-detail.module#UserDetailComponentModule'},
  { path: 'reports', loadChildren: './components/reports/reports.module#ReportsComponentModule'},
  { path: 'messages', loadChildren: './components/messages/messages.module#MessagesComponentModule'},
  { path: 'about', loadChildren: './components/about/about.module#AboutComponentModule' }
] 

@NgModule({
  imports: [ RouterModule.forRoot(routes)],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
